import appIcons from '../data/index.jsx';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
/**
 * Take an array of tab objects and returns a new array of tab objects with icons. If the icon is not found, it will return a default icon.
 * @function addIcons
 * @param { array } tabs
 * @returns { array }
 */
function addIcons(tabs) {
	const tabWithIcons = tabs.map((tab) => {
		const _icon = appIcons.find(
			(appIcon) => appIcon.name.toLowerCase() === tab.name.toLowerCase(),
		)?.icon || <BrokenImageIcon />; // If the icon is not found, return a default icon.

		return {
			...tab,
			icon: _icon,
		};
	});

	return tabWithIcons;
}

export default addIcons;
